import { Box, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

const networkRoles = ["PLAYER", "COACH", "SCOUT", "AGENT", "OTHER"];

const PersonaFilter = ({ isDataLoading }: { isDataLoading: boolean }) => {
  const { t } = useTranslation("common", {
    keyPrefix: "user.role",
  });

  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentRole = searchParams.get("role")?.toUpperCase();

  const handleOnChangeType = (role: string) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("role", role);
    navigate({ search: searchParams.toString() });
  };

  return (
    <Box sx={styles.container}>
      {networkRoles.map((role) => (
        <Chip
          key={role}
          label={t(role)}
          component="button"
          variant="outlined"
          clickable
          onClick={() => handleOnChangeType(role)}
          disabled={isDataLoading}
          sx={styles.chip(currentRole ?? "", role)}
        />
      ))}
    </Box>
  );
};

export default PersonaFilter;

const styles = {
  container: {
    display: "flex",
    gap: "8px",
  },
  chip: (currentRole: string, role: string) => ({
    padding: "1px 4px",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    color: currentRole === role ? "var(--Green---100, #008B07)" : "var(--Dark---600, #707070)",
    border: currentRole === role ? "1px solid var(--Brand-600, #008B07)" : "none",
    background: currentRole === role ? "var(--Brand-25, #F6FFF5)" : "transparent",
  }),
};
